import { render, staticRenderFns } from "./DetailSectionContent.vue?vue&type=template&id=28ca960a&scoped=true"
import script from "./DetailSectionContent.vue?vue&type=script&lang=js"
export * from "./DetailSectionContent.vue?vue&type=script&lang=js"
import style0 from "./DetailSectionContent.vue?vue&type=style&index=0&id=28ca960a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ca960a",
  null
  
)

export default component.exports